module.exports = __webpack_public_path__ + "static/media/16UNODC11.7a30c568.jpg";